import script from "./ProductsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsGrid.vue?vue&type=script&setup=true&lang=js"

import "./ProductsGrid.vue?vue&type=style&index=0&id=4ab9cc61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab9cc61"]])

export default __exports__